import React, { useState } from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";
import { Link } from "react-router-dom";
import Documents from "./Documents";
import Tools from "./Tools";

const Download = () => {
  ChangeTitle("Download");
  const [mainMenu, setMainMenu] = useState("Documents");

  return (
    <>
      <div className="w-full px-[3%] py-[5%] min-h-screen bg-yellow">
        <div className="w-full mb-[5%] md:mb-[2%]">
          <h1 className="hanson text-center mb-[1%] heading">Download</h1>
          <img
            className="mb-[2%] mx-auto"
            src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
            alt=""
          />
        </div>
        <div className="relative z-[5] mb-[-5rem] sm:mb-[-7rem] md:mb-[-5rem] lg:mb-[-7rem] w-max flex justify-evenly p-[2%] md:p-[1%] mx-auto rr-main-menu webinar-menu">
          <Link
            className={
              mainMenu === "Documents"
                ? "rrmm-box-active wm-box-active rrmm-box wm-box"
                : "rrmm-box wm-box"
            }
            onClick={() => setMainMenu("Documents")}
          >
            Documents
          </Link>
          <Link
            className={
              mainMenu === "Tools"
                ? "rrmm-box-active wm-box-active rrmm-box wm-box"
                : "rrmm-box wm-box"
            }
            onClick={() => setMainMenu("Tools")}
          >
            Tools
          </Link>
        </div>
        {mainMenu === "Documents" ? <Documents /> : ""}
        {mainMenu === "Tools" ? <Tools /> : ""}
      </div>
    </>
  );
};

export default Download;
